// CreateSubscription.js
import React, { useState } from 'react';
import { baseUrlUser } from './common'; // Adjust path as needed
import './createsubscription.css'; // Import updated CSS

const CreateSubscription = () => {
  const [clientId, setClientId] = useState('');
  const [product, setProduct] = useState('');
  const [plan, setPlan] = useState('');
  const [startDate, setStartDate] = useState('');
  const [numberOfYears, setNumberOfYears] = useState(0);
  const [numberOfMonths, setNumberOfMonths] = useState(0);
  const [numberOfUsers, setNumberOfUsers] = useState(1);
  const [message, setMessage] = useState('');

  const token = localStorage.getItem('treziAccessToken');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!startDate) {
      setMessage('Start date is required');
      return;
    }

    const dateObj = new Date(startDate);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const isoString = `${formattedDate}T10:00:00Z`;

    const payload = {
      clientId: clientId.trim(),
      startDate: isoString,
      product: product.trim(),
      ...(plan && plan.trim() !== '' ? { plan: plan.trim() } : {}),
      numberOfYears: parseInt(numberOfYears, 10) || 0,
      numberOfMonths: parseInt(numberOfMonths, 10) || 0,
      numberOfUsers: parseInt(numberOfUsers, 10) || 1,
    };

    try {
      const response = await fetch(`${baseUrlUser}payments/create/subscription`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Failed to create subscription. Status: ${response.status}, Response: ${text}`);
      }

      setMessage('✅ Subscription created successfully!');
      setClientId('');
      setProduct('');
      setPlan('');
      setStartDate('');
      setNumberOfYears(0);
      setNumberOfMonths(0);
      setNumberOfUsers(1);
    } catch (error) {
      setMessage(`❌ Error: ${error.message}`);
    }
  };

  return (
    <div className='main'>
    <div className="create-subscription-container">
      <h2>Create Subscription</h2>
   <form onSubmit={handleSubmit}>
  <div className="form-group">
    <label htmlFor="clientId">Client ID:</label>
    <input
      type="email"
      id="clientId"
      value={clientId}
      onChange={(e) => setClientId(e.target.value)}
      required
    />
  </div>

  <div className="form-group">
    <label htmlFor="product">Product:</label>
    <input
      type="text"
      id="product"
      value={product}
      onChange={(e) => setProduct(e.target.value)}
      required
    />
  </div>

  <div className="form-group">
    <label htmlFor="plan">Plan:</label>
    <input
      type="text"
      id="plan"
      value={plan}
      onChange={(e) => setPlan(e.target.value)}
    />
  </div>

  <div className="form-group">
    <label htmlFor="startDate">Start Date (UTC):</label>
    <input
      type="text"
      id="startDate"
      placeholder="2025-06-04T10:00:00Z"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
      required
    />
  </div>
  <div className="form-note">
    <small>Enter date/time in ISO format (YYYY-MM-DDTHH:mm:ssZ)</small>
  </div>

  <div className="form-group">
    <label htmlFor="numberOfYears">Number of Years:</label>
    <input
      type="number"
      id="numberOfYears"
      value={numberOfYears}
      onChange={(e) => setNumberOfYears(e.target.value)}
      min="0"
    />
  </div>

  <div className="form-group">
    <label htmlFor="numberOfMonths">Number of Months:</label>
    <input
      type="number"
      id="numberOfMonths"
      value={numberOfMonths}
      onChange={(e) => setNumberOfMonths(e.target.value)}
      min="0"
    />
  </div>

  <div className="form-group">
    <label htmlFor="numberOfUsers">Number of Users:</label>
    <input
      type="number"
      id="numberOfUsers"
      value={numberOfUsers}
      onChange={(e) => setNumberOfUsers(e.target.value)}
      min="1"
      required
    />
  </div>

  <button type="submit">Create Subscription</button>
</form>

      {message && <p>{message}</p>}
    </div>
    </div>
  );
};

export default CreateSubscription;
